"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snackbar_1 = require("@material-ui/core/Snackbar");
var SnackbarContentWrapper_1 = require("./SnackbarContentWrapper");
var CustomSnackbar = /** @class */ (function (_super) {
    __extends(CustomSnackbar, _super);
    function CustomSnackbar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function (_event) { return _this.setState({ open: false }); };
        _this.state = { open: true };
        return _this;
    }
    CustomSnackbar.prototype.render = function () {
        var _a = this.props, variant = _a.variant, message = _a.message, anchorOrigin = _a.anchorOrigin;
        var open = this.state.open;
        return (React.createElement(Snackbar_1.default, { anchorOrigin: Object.assign({}, {
                vertical: 'top',
                horizontal: 'center',
            }, anchorOrigin), open: open, onClose: this.handleClose },
            React.createElement(SnackbarContentWrapper_1.default, { variant: variant, message: message, onClose: this.handleClose })));
    };
    return CustomSnackbar;
}(React.Component));
exports.default = CustomSnackbar;
